export const fieldVisitHeaderElements = [
  { label: "Titular cuenta", value: "titularCuenta", align: "inherit" },
  { label: "Establecimiento", value: "establecimiento", align: "inherit" },
  { label: "Fecha deseada", value: "fechaDeseada", align: "inherit" },
  { label: "Estado", value: "displayEstado", align: "inherit" },
];
